import * as React from "react";
import MyLogo from './logo2.inline.svg';

const Logo = () => (
  <MyLogo />
)

export default Logo
